import { useModuleLicense } from './useModuleLicense';

/**
 * Who reads and writes Sales notes, follow-ups and issues: a Sales seat, or
 * a Nursery operator, manager or admin (the people who pack and send the
 * trees and see what went wrong). Never a picker. Mirrors HHNodeServer
 * `salesCrmService.CRM_SEATS`, which is the real gate.
 */
export function useCrmSeat() {
  const sales = useModuleLicense('sales', ['user', 'admin']);
  const nursery = useModuleLicense('nursery', ['operator', 'manager', 'admin']);
  return { hasAccess: sales.hasAccess || nursery.hasAccess, loading: sales.loading || nursery.loading };
}

/** `alsoModules` for a `LicenseGate moduleKey="sales"` on a CRM page a Nursery seat also opens. */
export const CRM_ALSO = [{ moduleKey: 'nursery', licenseType: ['operator', 'manager', 'admin'] }];
